import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DoneModule } from '@components/done/done.module';
import { InfoModule } from '@components/info/info.module';
import { SharedPipeModule } from '@app/shared/pipes/shared.pipe.module';
import { RouterModule } from '@angular/router';
import { AppComponent } from '@app/root/app.component';
import { FooterComponent } from '@components/footer/footer.component';
import { HeaderNotAuthenticatedModule } from '@components/headerNotAuthenticated/header-not-authenticated.module';
import { MainMaterialModule } from '@app/shared/mainComponent/mainMaterial.module';
import { WaitingModuleScopedModule } from '@components/waitingModuleScoped/waitingModuleScoped.module';
import { MatIconModule } from '@angular/material/icon';
import { MatBadgeModule } from '@angular/material/badge';
import { HeaderAuthenticatedComponent } from '@components/headerAuthenticated/header-authenticated.component';
import { ExtendedWaitingModuleModule } from '@components/extendedWaitingModule/extendedWaitingModule.module';

@NgModule({
  imports: [
    MainMaterialModule,
    HeaderNotAuthenticatedModule,
    DoneModule,
    InfoModule,
    CommonModule,
    MatIconModule,
    RouterModule,
    SharedPipeModule,
    WaitingModuleScopedModule,
    MatBadgeModule,
    HeaderAuthenticatedComponent,
    ExtendedWaitingModuleModule,
  ],
  declarations: [AppComponent, FooterComponent],
  exports: [FooterComponent],
})
export class AppComponentModule {}
